const pako = require('pako');
const base64 = require('base-64');

function parseOldProfileFormat(encodeProfile) {
  const profileString = pako.inflate(base64.decode(encodeProfile), {
    to: 'string',
  });
  return JSON.parse(profileString);
}

function getProfileFromToken(token) {
  if (!token || typeof token !== 'string') {
    throw new Error('Got invalid token!');
  }

  const jwtParts = token.split('.');

  if (jwtParts.length !== 3) {
    throw new Error('Token has invalid format: does not consist of 3 parts');
  }

  const jwtPayload = jwtParts[1];

  const payloadString = base64.decode(jwtPayload);
  const payload = JSON.parse(payloadString);

  if (payload.user) {
    return payload;
  }

  if (!payload.profile) {
    throw new Error('No profile property inside payload of JWT token');
  }

  return parseOldProfileFormat(payload.profile);
}

module.exports = {
  getProfileFromToken,
};
